import cn from 'classnames';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import ImageViewer from 'react-simple-image-viewer';
import default_image from '../../../../assets/media/icons/products.png';
import { Column, Row } from '../../../../components/Basic/Blocks';
import { NavLink } from '../../../../components/Basic/Elements';
import { TableCell, TableLine } from '../../../../components/Basic/Table';
import { TextGrey, Tooltip } from '../../../../components/Basic/WrapsStyle';
import ProviderList from '../../../../components/Common/Input/ProviderList';
import { MAP_SKLAD_SHORT, RETURN_STATE, TO_ENTRY, TO_SHIPMENT } from '../../../../constans';
import { formFullDate, getDateMonth } from '../../../../utils';
import { WIDTH_POSTING } from '../index';
import styles from './styles.module.scss';
import WarehouseStepperInput from './WarehouseStepperInput';

const STATE = {
  not_collected: { text: 'Не обработан', color: '' },
  not_started: { text: 'Не собран', color: '' },
  started: { text: 'Комплектуется', color: 'rgb(255 112 0 / 18%)' },
  collected: { text: 'Ожидает упаковки', color: 'rgb(88 143 255 / 37%)' },
  packed: { text: 'Упакован', color: 'rgb(69 255 156 / 51%)' },
  printed: { text: 'Упакован', color: '#39ee3f47' },
};

const WarehouseLine = ({
  shipmentMode = true,
  order = {},
  shipment = {},
  map = {},
  postingsPrint = {},
  entriesArray = [],
  changePostingPrint = (_) => _,
  printSticker = (_) => _,
  changePrintStatus = (_) => _,
  updatePosting = (_) => _,
  ...props
}) => {
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const [images, setImages] = useState([]);

  const dispatch = useDispatch();

  const openImageViewer = (images) => {
    setImages(images);
    setIsViewerOpen(true);
  };
  const closeImageViewer = () => {
    setIsViewerOpen(false);
    setImages([]);
  };

  const scan_time_first = order.scan_time?.['pick'] ? formFullDate(order.scan_time?.['pick']) : null;
  const scan_time_order = order.scan_time?.packager ? formFullDate(order.scan_time?.packager) : null;

  let entryItem = entriesArray.find((ea) => ea.posting.number === order.posting_number);
  return (
    <TableLine key={order.number} style={entryItem?.entry_id ? { background: 'rgb(105 217 109 / 28%)' } : {}}>
      <TableCell width={WIDTH_POSTING[0]}>
        {/*        <Link to={TO_POSING(order.posting_number)} className={styles.link}>
          {order.posting_number}
        </Link>*/}
        {order.posting_number}
        {order.market === 'wb' && <span className={styles.wb_sticker}>{order.sticker_parts?.second}</span>} <br />
        <Row style={{ width: '100%' }}>
          {order.market === 'wb' && <TextGrey style={{ fontSize: '18px', color: '#6c11c9' }}>{order.shop}</TextGrey>}
          {order.market === 'yandex' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(193 61 0)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'ozon' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(19,79,231)' }}>{order.shop}</TextGrey>
          )}
          {order.market === 'megamarket' && (
            <TextGrey style={{ fontSize: '18px', color: 'rgb(13,131,25)' }}>{order.shop}</TextGrey>
          )}
        </Row>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} center>
        <NavLink
          to={TO_SHIPMENT(order.shipment_id)}
          target={'_blank'}
          className={styles.scan_time}
          style={{ fontSize: '18px' }}
        >
          {getDateMonth(order.dates.shipment_date)}
        </NavLink>
      </TableCell>
      <TableCell width={WIDTH_POSTING[1]}>
        <Column>
          {order.products.map((p, k) => {
            const data = map[p.offer_id] || {};
            const img = data.images ? (data.images.length > 0 ? data.images : [default_image]) : [default_image];
            return (
              <div key={k} className={styles.div_line_images}>
                <div className={styles.wrapper}>
                  <img
                    onClick={() => openImageViewer(img)}
                    className={styles.preview}
                    src={img.length > 0 ? img[0] : undefined}
                  />
                </div>
                <Column>
                  <div className={styles.name}>
                    {`${p.ordered_quantity} x ${p.name}  `}
                    <div className={cn(styles.offer_id, p.status === 'Нет в наличии' && styles.red_text)}>
                      {p.offer_id}
                    </div>
                  </div>
                </Column>
              </div>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        {order.products.map((p, k) => {
          return (
            <Column style={{ alignItems: 'center' }}>
              <div key={k} style={{ fontWeight: 'bold', fontSize: '16px' }}>
                {p.provider_sku}
              </div>
            </Column>
          );
        })}
      </TableCell>

      <TableCell width={WIDTH_POSTING[5]} center={true}>
        <Column>
          {order.products.map((p, k) => {
            // eslint-disable-next-line react/no-array-index-key

            return (
              <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
                {(p['diff'].comment || '').length > 0 ? (
                  <>
                    <Tooltip text={p['diff'].comment}>
                      {p.diff.status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`} *
                    </Tooltip>
                  </>
                ) : (
                  <>
                    {p['diff'].status} {p['diff'].value !== 0 && p['diff'].value !== null && ` (${p['diff'].value})`}
                  </>
                )}
              </Row>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <Column>
          {order.products.map((p, k) => {
            // eslint-disable-next-line react/no-array-index-key

            let entryItem = entriesArray.find(
              (ea) => ea.posting.number === order.posting_number && ea.product.offer_id === p.offer_id,
            );
            return (
              <Row key={`${order.posting_number}-${p.offer_id}-19`} className={styles.div_line} center={true}>
                <WarehouseStepperInput item={p} order={order} save={(data) => updatePosting(data)} entryItem={entryItem} />
              </Row>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <Column>
          {order.products.map((p, k) => {
            // eslint-disable-next-line react/no-array-index-key

            let entryItem = entriesArray.find(
              (ea) => ea.posting.number === order.posting_number && ea.product.offer_id === p.offer_id,
            );
            return (
              <Row key={`${order.posting_number}-${p.offer_id}-22`} className={styles.div_line} center={true}>
                {entryItem?.entry_id ? (
                  <>
                    <Link to={TO_ENTRY(entryItem.entry_id)} className={styles.link}>
                      <div className={cn(styles.status, styles.sold)}>
                        {RETURN_STATE['confirmed']}
                        <TextGrey fontSize={10} style={{ marginTop: '-5px', fontSize: '12px' }}>
                          {formFullDate(entryItem.scan.date)}
                        </TextGrey>
                      </div>
                    </Link>
                  </>
                ) : (
                  <div className={cn(styles.status, styles.process)}>{RETURN_STATE['new']}</div>
                )}
              </Row>
            );
          })}
        </Column>
      </TableCell>
      <TableCell width={WIDTH_POSTING[4]} center={true}>
        <div
          className={cn(
            styles.status,
            order.status === 'Ожидает отгрузки' && styles.process,
            order.status === 'Не принят на CЦ' && styles.waiting,
            order.status === 'Идёт приёмка' && styles.waiting,
            order.status === 'Доставляется' && styles.sorted,
            order.status === 'Прибыл на ПВЗ' && styles.pickup,
            order.status === 'Продано' && styles.sold,
            order.status === 'Доставлено' && styles.sold,
            order.status === 'Отменено' && styles.canceled,
            order.status === 'Отменено клиентом' && styles.controversial,
            order.status === 'Арбитраж' && styles.controversial,
            order.status === 'Обнаружен брак' && styles.waiting,
            order.cancellation?.is_return && styles.return,
          )}
        >
          {order.cancellation?.is_return ? 'Возврат' : order.status}
        </div>
      </TableCell>
      <TableCell width={WIDTH_POSTING[12]} center>
        <div>{MAP_SKLAD_SHORT[order.sklad]}</div>
      </TableCell>

      <TableCell width={WIDTH_POSTING[4]}>
        <Column style={{ alignItems: 'center' }}>
          {order.products.map((p, k) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={k} className={styles.div_line}>
              <ProviderList selectProviderId={p.provider_id} disabled={true} />
            </div>
          ))}
        </Column>
      </TableCell>


      {isViewerOpen && <ImageViewer src={images} currentIndex={0} onClose={closeImageViewer} />}
    </TableLine>
  );
};

export default WarehouseLine;
